import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgPipesModule } from 'ngx-pipes';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ButtonsModule } from 'ngx-bootstrap';
import { AccordionModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ShoppingcartComponent } from './components/shoppingcart/shoppingcart.component';
import { SweetAlert2Module } from '@toverux/ngsweetalert2';
import { BusyModule, BusyConfig } from 'angular2-busy';
import { KeysPipe } from './components/keys.pipe';
import { FillPipe } from 'app/shared/components/fill.pipe';

import {
    DataTableModule,
    SharedModule as PrimeSharedModule
} from 'primeng/primeng';

import { SharedService } from './shared.service';
// import components/modules here

export function busyConfig() {
    return new BusyConfig({
        message: 'Vennligst vent',
        backdrop: true,
        template: '<div class="sk-fading-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div>',
        // wrapperClass: 'my-class'
    });
}

@NgModule({
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    imports: [
        CommonModule,
        FormsModule,
        NgPipesModule,
        NgxDatatableModule,
        BusyModule,
        DataTableModule,
        PrimeSharedModule,
        AccordionModule.forRoot(),
        ButtonsModule.forRoot(),
        ModalModule.forRoot(),
        SweetAlert2Module.forRoot(),
    ],
    declarations: [
        ShoppingcartComponent,
        KeysPipe,
        FillPipe
    ],
    // providers: [
    //     SharedService
    // ],
    exports: [
        CommonModule,
        FormsModule,
        NgPipesModule,
        NgxDatatableModule,
        BusyModule,
        DataTableModule,
        PrimeSharedModule,
        AccordionModule,
        ButtonsModule,
        ModalModule,
        ShoppingcartComponent,
        SweetAlert2Module,
        KeysPipe,
        FillPipe
    ],
    providers: [
        { provide: BusyConfig, useFactory: busyConfig }
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [SharedService]
        };
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts